import React, { useMemo } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { FiCheck, FiHome, FiPhone, FiX } from 'react-icons/fi';
import './thank-you-aggregator.css';

const SUPPORT_PHONE = '9654036678';
const SUPPORT_TEL = `+91${SUPPORT_PHONE}`;

const ThankYouAggregator = () => {
  const [searchParams] = useSearchParams();
  const status = searchParams.get('status');
  const isSuccess = status === '1' || status === 'success' || status === null;

  const content = useMemo(() => {
    if (isSuccess) {
      return {
        badge: 'APPLICATION RECEIVED',
        title: 'Thank you',
        message:
          'Your loan application has been submitted successfully. Our team will contact you shortly.',
        icon: 'success',
      };
    }

    return {
      badge: 'APPLICATION PENDING',
      title: 'Almost there',
      message:
        'We could not confirm your application right now. Please try again or call our support team for help.',
      icon: 'error',
    };
  }, [isSuccess]);

  return (
    <div className={`ty-agg ${isSuccess ? 'is-success' : 'is-error'}`}>
      <div className="ty-agg__card">
        <div className="ty-agg__glow" aria-hidden="true" />
        <div className="ty-agg__icon-ring">
          {content.icon === 'success' ? <FiCheck strokeWidth={2.75} /> : <FiX strokeWidth={2.75} />}
        </div>

        <span className="ty-agg__badge">{content.badge}</span>
        <h1 className="ty-agg__title">{content.title}</h1>
        <p className="ty-agg__message">{content.message}</p>

        <div className="ty-agg__actions">
          <Link to="/" className="ty-agg__btn ty-agg__btn--primary">
            <FiHome />
            <span>Back to Home</span>
          </Link>
          <a href={`tel:${SUPPORT_TEL}`} className="ty-agg__btn ty-agg__btn--outline">
            <FiPhone />
            <span>Call Support</span>
          </a>
        </div>
      </div>
    </div>
  );
};

export default ThankYouAggregator;
